import {
  AllAdmins,
  HubAdmin,
  PlatformAdmin,
  SiteAdmin,
} from 'lib/authorization/Roles'
import { RANGE_TYPES } from 'lib/GlobalConstants'

export const FILTER_LIST = [
  {
    name: 'dateRange',
    disabled: true,
    isDefault: true,
    icon: 'date_range',
    component: 'DateRangeFilter',
    dateRangeOption: RANGE_TYPES.week,
    hidden: true,
    isSelected: true,
    allowedTo: [AllAdmins],
    calculatedRange: '',
    isDateRangePickerOpen: false,
  },
  {
    name: 'projects',
    tooltipText: '',
    icon: 'web',
    iconStyle: 'outlined',
    component: 'Projects',
    allowedTo: [AllAdmins],
    category: 'project',
  },
  {
    name: 'projectStatus',
    tooltipText: '',
    iconStyle: 'outlined',
    icon: 'playlist_add_check',
    component: 'ProjectStatus',
    allowedTo: [AllAdmins],
    category: 'project',
  },
  {
    name: 'projectTag',
    tooltipText: '',
    icon: 'label_important',
    component: 'ProjectTags',
    allowedTo: [AllAdmins],
    category: 'project',
  },
  {
    name: 'participantType',
    tooltipText: '',
    iconStyle: 'outlined',
    icon: 'people',
    component: 'ParticipantTypes',
    allowedTo: [AllAdmins],
  },
  {
    name: 'participantsGroups',
    tooltipText: '',
    iconStyle: 'outlined',
    icon: 'person_pin',
    component: 'ParticipantGroups',
    allowedTo: [AllAdmins],
  },
  {
    name: 'dashboardLocation',
    tooltipText: '',
    icon: 'location_on_outlined',
    iconStyle: 'outlined',
    component: 'Location',
    category: 'location',
    allowedTo: [AllAdmins],
  },
  {
    name: 'yearOfBirth',
    tooltipText: '',
    iconStyle: 'outlined',
    icon: 'insert_invitation',
    component: 'YearsOfBirth',
    allowedTo: [AllAdmins],
  },
  {
    name: 'ethnicity',
    tooltipText: '',
    iconStyle: 'outlined',
    icon: 'groups',
    component: 'Ethnicity',
    allowedTo: [AllAdmins],
  },
  {
    name: 'gender',
    tooltipText: '',
    icon: 'transgender_outlined',
    component: 'Gender',
    allowedTo: [AllAdmins],
  },
  {
    name: 'page',
    tooltipText: '',
    iconStyle: 'outlined',
    icon: 'description',
    component: 'Pages',
    allowedTo: [PlatformAdmin, SiteAdmin, HubAdmin],
  },
  {
    name: 'hub',
    tooltipText: '',
    icon: 'device_hub',
    component: 'Hubs',
    allowedTo: [PlatformAdmin, SiteAdmin, HubAdmin],
  },
]
